"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
const DataIndexValues = ['Alert', 'Attachment', 'Audit', 'Case', 'Log', 'Observable', 'Tag', 'Task'];
const DatabaseCheckValues = [
    'Alert',
    'Case',
    'CaseTemplate',
    'CustomField',
    'Data',
    'ImpactStatus',
    'ObservableType',
    'Organisation',
    'Profile',
    'ResolutionStatus',
    'Tag',
    'User',
];
